export default __webpack_public_path__ + "static/media/UserTie2.5890d3d1.svg";